import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { provideGlobalGridOptions } from 'ag-grid-community';

import { BaasI18n } from '@lvflanders/bar';
import { provideBaasInitialized } from '@lvflanders/bar-ng';

import { BAR_AG_GRID_I18N } from './bar-ag-grid.i18n';
import { BAR_AG_GRID_LOCALE } from './bar-ag-grid-locale';
import { BarAgGridInitializedHook } from './hooks/bar-ag-grid-initialized.hook';
import { themeLv } from './theming/theme-lv';

export function provideBarAgGrid(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideEnvironmentInitializer(() => {
            inject(BaasI18n).addTranslations('DOMAIN_BAR_AG_GRID', BAR_AG_GRID_I18N);
            provideGlobalGridOptions({ localeText: BAR_AG_GRID_LOCALE, theme: themeLv });
        }),
        provideBaasInitialized(BarAgGridInitializedHook)
    ]);
}
